import { Toolbar, ToolbarProps } from '@mui/material'
import React, { FC } from 'react'

const ToolbarWrapper: FC<ToolbarProps> = ({ ...props }) => <Toolbar {...props} />

export default ToolbarWrapper
